import { cn } from '@/lib/utils'
import { GaugeRing } from './GaugeRing'
import { Button } from '../ui/button'

export interface ProfitItem {
	id: string
	symbol: string
	amount: string
	decimals: string
	percent: number
	ringColor: string
	badgeBgClassName: string
	badgeTextClassName: string
	active?: boolean
}

export function ProfitCard({ item }: { item: ProfitItem }) {
	return (
		<div className={cn('flex w-[300px] shrink-0 snap-start flex-col gap-1 rounded-2xl border p-1 sm:w-[480px] sm:flex-row', item.active ? 'border-primary' : 'border-border')}>
			<div className='flex h-[142px] shrink-0 items-center justify-center rounded-xl bg-background sm:w-[243px]'>
				<GaugeRing percent={item.percent} color={item.ringColor} />
			</div>

			<div className='flex flex-1 flex-col gap-3 p-3'>
				<div className='flex flex-col gap-1.5'>
					<div className='flex items-center gap-2'>
						<span className={cn('flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[10px] font-bold text-foreground', item.badgeBgClassName)}>
							{item.symbol.slice(0, 1)}
						</span>
						<span className='flex-1 text-base font-medium tracking-[-0.24px] text-foreground'>{item.symbol}</span>
						<span className={cn('rounded-full px-1.5 py-0.5 text-sm font-semibold tracking-[-0.21px]', item.badgeBgClassName, item.badgeTextClassName)}>
							{item.symbol}
						</span>
					</div>
					<div className='tracking-[-0.24px]'>
						<span className='text-2xl font-semibold text-foreground'>{item.amount}</span>
						<span className='text-base font-semibold text-muted-foreground'>{item.decimals}</span>
					</div>
				</div>
				<Button variant='primary' disabled={!item.active}>
					Claim
				</Button>
			</div>
		</div>
	)
}
